import React from 'react';
import styled from 'styled-components';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Fab, Tooltip } from '@mui/material';
import useFormStore from '../state/useFormStore';
import { config } from '../config';

const FloatingButton = styled(Fab)`
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  background-color: #25D366 !important;
  &:hover {
    background-color: #128C7E !important;
  }
`;

const WhatsAppButton = () => {
  const { first_name, last_name, dni } = useFormStore((state) => ({
    first_name: state.first_name,
    last_name: state.last_name,
    dni: state.dni
  }));

  const phoneNumber = config.business.phone;

  if (!phoneNumber) {
    console.warn('WhatsApp button disabled, phone number not defined.');
    return null;
  }

  const handleClick = () => {
    let message = 'Hola, necesito ayuda con mi solicitud de préstamo';
    
    if (first_name && last_name && dni) {
        const userInfo = `${first_name} ${last_name} (DNI: ${dni})`;
        message = `Hola, soy ${userInfo}. Necesito ayuda con mi solicitud de préstamo`;
    }
    
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      '_blank'
    );
  };

  return (
    <Tooltip title="¿Necesitás ayuda?" placement="left">
      <FloatingButton
        color="primary"
        onClick={handleClick}
        size="large"
        aria-label="whatsapp"
      >
        <WhatsAppIcon />
      </FloatingButton>
    </Tooltip>
  );
};

export default WhatsAppButton; 